module.exports = __webpack_public_path__ + "img/portrait-047.dc19ffeb.jpg";